import { Button } from '@usitsdasdesign/dds-react'
import Text from 'atoms/Text'
import AsyncReactSelectPaginate from 'molecules/AsyncReactSelectPaginate'
import React, { useState } from 'react'

const RenderUser = ({ data }) => {
    return (
        <div className={`p-1.5`} >
            <div className='flex gap-1 items-center'>
                <Text>{data.name}</Text>
                <Text variant='label' className='text-gray-900'> ({data.employeeCode})</Text>
            </div>
            <Text variant='label' className='text-gray-900'>
                {data.designation} | {data.email} | {data.subServiceArea}
            </Text>
        </div>
    );
};

const findItemsInArray1NotInArray2 = (arr1, arr2) => arr1.filter((item1) => !arr2.some((item2) => item2.employeeCode === item1.employeeCode));

function AddUserRA({
    title = 'Approvers',
    isRequired = true,
    control,
    register = () => false,
    name = 'name',
    defaultValue,
    className = '',
    values = [],
    setValue = () => false,
    isError,
    errorMessage,
    setError,
    clearErrors,
    max = 3,
    ...rest
}) {
    const [showSelector, setShowSelector] = useState(false);
    const [deletedElement, setDeletedElement] = useState(null);

    const getNextSequentialNumber = () => {
        const existingNumbers = values.map(v => v.approverNo).sort((a, b) => a - b);
        let expectedNumber = 1;
        
        for (const num of existingNumbers) {
            if (num === expectedNumber) {
                expectedNumber++;
            } else {
                break;
            }
        }
        
        return expectedNumber;
    };

    const handleAddApprover = (item) => {
        if (item === null) return;

        let result = findItemsInArray1NotInArray2(item, values);
        result = result[0];

        if (deletedElement) {
            result.approverNo = deletedElement.approverNo;
            result.isMaster = false;
            setDeletedElement(null);
        } else {
            result.approverNo = getNextSequentialNumber();
            result.isMaster = false;
        }
        
        const updated = [...values, result].sort((a, b) => a.approverNo - b.approverNo);
        setValue(name, updated);
        setShowSelector(false);
    };

    const handleDeleteApprover = (item, index) => {
        if (item.approverNo === 1) {
            setDeletedElement(item);
        }
        const updated = values.filter((_, i) => i !== index);
        setValue(name, updated);
    };
    
    return (
        <div className={className}>
            <div className='flex items-center gap-2 justify-between mb-2'>
                <Text variant='labelSemibold'>{title} {isRequired && <span className='text-red-900'>*</span>}</Text>
                <Button
                    label='Add'
                    icon='plus__s__stroke'
                    size='m'
                    kind='silent'
                    onClick={() => setShowSelector(true)}
                    isDisabled={values.length >= max}
                />
            </div>

            {
                showSelector ? (
                    <AsyncReactSelectPaginate
                        control={control}
                        register={register}
                        onChange={handleAddApprover}
                        name={name}
                        defaultValue={defaultValue}
                        menuIsOpen
                        hideSelectedOptions={true}
                        className='add-user-dropdown'
                        isClearable={false}                                    
                        backspaceRemovesValue={false}
                        {...rest}
                    />
                ) : (
                    values.length === 0 && <Text className='text-gray-900'>No Approvers added</Text>
                )
            }

            {
                values.length > 0 && (
                    <div className='mb-4'>
                        {
                            values.map((item, i) => {
                                return (
                                    <div key={i} className='flex items-center justify-between gap-4 border-b border-gray-200'>
                                        <div className='flex items-center gap-4 flex-1'>
                                            <Text variant='label' className='flex-none'>Approver level {item.approverNo}</Text>
                                            <RenderUser data={item} />
                                        </div>
                                        <Button
                                            icon='delete__s__stroke'
                                            className='flex-none'
                                            kind='silent'
                                            onClick={() => handleDeleteApprover(item, i)}
                                            isDisabled={item?.isMaster}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }

            {isError && <div className="text-red-900 text-[12px] pt-1 error-in-field">{errorMessage}</div>}
        </div>
    )
}

export default AddUserRA;